import api from '@/api';

import { API_BASE_URL } from '..';
import { ReportDocumentTypesParams } from './Report.types';

const baseUrl = API_BASE_URL;

export async function generateDocumentTypeReport(
  params?: ReportDocumentTypesParams,
) {
  const result = (await api.getReport(
    `${baseUrl}/generate/documenttypes`,
    params,
  )) as unknown;

  return result as BlobPart;
}
